KEY_RETRY_ATTEMPT